import { render } from "./QNetworkCharacteristics.vue?vue&type=template&id=fff7c8b4&ts=true"
import script from "./QNetworkCharacteristics.vue?vue&type=script&lang=ts"
export * from "./QNetworkCharacteristics.vue?vue&type=script&lang=ts"

import "./QNetworkCharacteristics.vue?vue&type=style&index=0&id=fff7c8b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__